<ngx-loading-bar [includeSpinner]='false' color='#298c8d'></ngx-loading-bar>
<router-outlet></router-outlet>
